<section class="content-wrap">
  <div class="content-main">
    <div class="content-container">
      <div class="header-title">
        <div class="heading-content">
          <h4 class="color-dark tab-analytics">
            Settings
            <span class="span-tab">
              <span
                class="sub-span-tab active"
                (click)="changeSetting('availability')"
                [class.active]="activeTabSetting == 'availability'"
                >Availability</span
              >
              <span
                class="sub-span-tab"
                (click)="changeSetting('marketing')"
                [class.active]="activeTabSetting == 'marketing'"
                >Marketing</span
              >
              <span
                class="sub-span-tab"
                (click)="changeSetting('token')"
                [class.active]="activeTabSetting == 'token'"
                >Token</span
              >
            </span>
          </h4>
        </div>
        <ng-container *ngIf="activeTabSetting == 'availability'">
          <div class="middle-content">
            <div class="left-middle middle-240">
              <div class="menu-wrap">
                <ul>
                  <li>
                    <a
                      (click)="changeNav('serviceAccessCity')"
                      [class.active]="activeTabNav == 'serviceAccessCity'"
                    >
                      <span>Service Access (City)</span>
                    </a>
                  </li>
                  <li>
                    <a
                      (click)="changeNav('serviceAccessCountry')"
                      [class.active]="activeTabNav == 'serviceAccessCountry'"
                    >
                      <span>Service Access (Country)</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="right-content">
              <div class="main-content">
                <ng-container *ngIf="activeTabNav === 'serviceAccessCity'">
                  <app-service-access-table></app-service-access-table>
                </ng-container>
                <ng-container *ngIf="activeTabNav === 'serviceAccessCountry'">
                  <app-service-access-country-table></app-service-access-country-table>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="activeTabSetting == 'marketing'">
          <div class="middle-content">
            <div class="left-middle middle-240">
              <div class="menu-wrap">
                <ul>
                  <li>
                    <a
                      (click)="changeNav('ride')"
                      [class.active]="activeTabNav == 'ride'"
                    >
                      <span>Ride</span>
                    </a>
                  </li>
                  <li>
                    <a
                      (click)="changeNav('yacht')"
                      [class.active]="activeTabNav == 'yacht'"
                    >
                      <span>Yacht</span>
                    </a>
                  </li>
                  <li>
                    <a
                      (click)="changeNav('rental')"
                      [class.active]="activeTabNav == 'rental'"
                    >
                      <span>Rental</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="right-content">
              <div class="main-content">
                <ng-container *ngIf="activeTabNav === 'ride'">
                  <app-ride-marketing-table></app-ride-marketing-table>
                </ng-container>
                <ng-container *ngIf="activeTabNav === 'yacht'">
                  <app-yacht-marketing-table></app-yacht-marketing-table>
                </ng-container>
                <ng-container *ngIf="activeTabNav === 'rental'">
                  <app-rental-marketing-table></app-rental-marketing-table>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="activeTabSetting == 'token'">
          <div class="middle-content">
            <div class="right-content" style="width: 100%">
              <div class="main-content">
                <app-uber-token></app-uber-token>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
